const getOpacityValueFromHexColor = (value: string) => {
  return value.slice(7);
};

export default getOpacityValueFromHexColor;
